import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';

import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import { LanguageInterceptor } from './shared/interceptors/language.interceptor';
import { provideLanguage } from './shared/providers/language.provider';
import { GoogleMapsLoaderService } from './shared/services/google-maps-loader.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      })
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([LanguageInterceptor])
    ),
    provideTranslateService({
      lang: 'es',
      fallbackLang: 'es', 
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json',
      }),
    }),
    provideAppInitializer(() => {
      const translate = inject(TranslateService);
      translate.use(translate.getBrowserLang() || 'es');
    }),
    importProvidersFrom(MatSnackBarModule),
    provideLanguage(),
    provideAppInitializer(() => {
      inject(GoogleMapsLoaderService).load();
    })
  ],
};
